import { render, staticRenderFns } from "./JSONSchemaForm.vue?vue&type=template&id=d2a08908&"
import script from "./JSONSchemaForm.vue?vue&type=script&lang=js&"
export * from "./JSONSchemaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/JSONSchemaForm.vue
// module id = null
// module chunks = 